import {
  formatToMoney,
  formatCurrencyAndTwoDecimalsString
} from "../../../../lib/formatter";
import { timeDurationDropdown } from "../VariableStatic";

export class ConferenceSearchPerDate {
  constructor(conferenceProject) {
    const person = "ท่าน";

    let dateSelect = "-";
    let conferenceProjectByDate = {};
    for (let prop in conferenceProject) {
      dateSelect = prop;
      conferenceProjectByDate = conferenceProject;
    }

    const conferenceProjects =
      conferenceProjectByDate[dateSelect] &&
      conferenceProjectByDate[dateSelect].length > 0
        ? conferenceProjectByDate[dateSelect]
        : [];

    const conferenceProjectListByDate = conferenceProjects
      ? conferenceProjects.map(conferenceProject => {
          let limitPeople = "-";
          if (conferenceProject.limit) {
            if (conferenceProject.limit.from && conferenceProject.limit.to) {
              limitPeople = `${conferenceProject.limit.from} - ${conferenceProject.limit.to}`;
            } else if (conferenceProject.limit.from) {
              limitPeople = conferenceProject.limit.from;
            }
          }

          const pricePackagePerUnitText = `${formatCurrencyAndTwoDecimalsString(
            conferenceProject.price_package_per_unit,
            2,
            "฿"
          )}/${person}`;

          return {
            conferenceId: conferenceProject.id,
            title: conferenceProject.title || "-",
            detail: conferenceProject.detail || "-",
            image: conferenceProject.images[0],
            limit: `${limitPeople} ${person}`,
            address: conferenceProject.address || "-",
            conferencePrice:
              formatToMoney(conferenceProject.price, 2, "$") || "",
						conferencePricePackagePerUnit: pricePackagePerUnitText
          };
      })
      : [];

    this.dateSelect = dateSelect;
    this.conferenceProjectListByDate = conferenceProjectListByDate;
  }
}



// WEBPACK FOOTER //
// ./src/components/other-web/Conference/Presenters/ConferenceSearchPerDate.js